import { render } from "./BannerSeven.vue?vue&type=template&id=c08277ec"
import script from "./BannerSeven.vue?vue&type=script&lang=js"
export * from "./BannerSeven.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__